import { TOGGLE_FS_ANALYTICS_BU_FILTER } from "../../../../../actions";

export const toggleFSAnalyticsBUFilter = (payload) => ({
  type: TOGGLE_FS_ANALYTICS_BU_FILTER,
  payload,
});
